import React from "react"
import AuthContext from 'store/AuthContext'
import AccountService from "services/AccountService"
import {PasswordField} from './PasswordField';
import { Container, FormLabel, FormControl, Button } from 'react-bootstrap';
import { useLanguage } from "pages/dimension/LanguageContext";

export const DeleteAccount: React.FC<{logoutCallback?: ()=> void}> = (props) => {
    const authCtx = React.useContext(AuthContext);
    const langCtx = useLanguage();

    const [inProgress, setInProgress] = React.useState(false)

    const [message, setMessage] = React.useState<string | null>(null);
    const [error, setError] = React.useState<string | null>(null);

    const passwordRef = React.useRef<HTMLInputElement>(null);

    function deleteClick() {
        console.log("deleteClick")
        setMessage(null);
        setError(null);
        if (!passwordRef.current!.value) {
            setError("Enter your password to confirm deletion");
            return;
        }

        if (!window.confirm("Do you want to delete your account and all dimensions owned by it? This cannot be undone.")) {
            return;
        }

        console.log(`Deleting account: ${authCtx.account.id}`);
        setMessage("Deleting account..");
        setInProgress(true)
        AccountService.deleteCurrentAccount(passwordRef.current!.value)
            .catch((error: string) => {
                setError(`Failed to delete account: ${error}`);
            })
            .finally(()=> {
                setInProgress(false)
                setMessage(null);
            })
    }

    if (!authCtx.account.valid()) {
        return (
            <b>Logged out.</b>
        );
    }

    return (
        <Container className="d-flex flex-column">
            <div style={{ marginBottom: "10px"}}>
                <FormLabel htmlFor="delPasswordInput">{langCtx.translate('Enter Your Password')}</FormLabel>
                <FormControl id="delPasswordInput" type="password" ref={passwordRef} />
            </div>
            { message && (<p className="text-secondary">{message}</p>)}
            { error && (<p className="text-danger">{error}</p>)}
            <Button variant="danger" disabled={inProgress} style={{ width: "200px"}} onClick={deleteClick}>{langCtx.translate('Delete Account')}</Button>
        </Container>
    );
};
